import { registerProjectDataSection } from '@trimble/project-data-panel-ui/registry';
import type { JSX } from 'solid-js';
import { ModelTree } from './model-tree/ModelTree';

const unregister = registerProjectDataSection('models', {
  render: (context): JSX.Element => (
    <ModelTree
      {...context.operations}
      repository={context.repository}
      multiSelect={context.config.multiSelect}
      defaultExpandIds={
        context.config.initiallyExpanded ? ['tcModels'] : undefined
      }
    />
  ),
});

if (import.meta.hot) {
  import.meta.hot.dispose(unregister);
}
